<template>
  <div>
    <base-label id="vector-provider" label="Vector provider" :label-classes="'font-medium'" :is-admin="true"/>
    <BaseToggleGroup class="mt-1" :tabs="providerOptions" v-model="provider"/>
    <div v-if="provider === 'qdrant'" class="mt-3">
      <base-label id="qdrant-model" label="Embedding model" :is-admin="true"/>
      <base-select id="qdrant-model"
                   :value="embeddingModel"
                   :options="embeddingModels"
                   class="w-full h-10 mt-1"
                   @input="embeddingModel = $event"
      />
    </div>
  </div>
</template>

<script>
import indexesService from '@/services/amio/indexes.service'

const DEFAULT_EMBEDDING_MODEL = 'text-embedding-3-small'

// Lets the admin pick the vector provider for a knowledge base. Default Azure keeps existing
// behavior; Qdrant adds the embedding model the engine/indexer use. The target collection is NOT
// chosen here — the indexer resolves it per source type (url->products, file/web->documents) with
// an optional per-org override in Settings → Vector Collections.
// Emits `input` with { provider } or { provider: 'qdrant', provider_params: { embeddingModel } }.
export default {
  name: 'SettingsIndexProvider',
  props: {
    value: {
      type: Object,
      default: () => ({ provider: 'azure' })
    }
  },
  data() {
    const params = this.value.provider_params || {}
    return {
      provider: this.value.provider || 'azure',
      embeddingModel: params.embeddingModel || DEFAULT_EMBEDDING_MODEL,
      embeddingModels: [DEFAULT_EMBEDDING_MODEL]
    }
  },
  async created() {
    try {
      const models = await indexesService.getEmbeddingModels()
      if (models && models.length) this.embeddingModels = models
    } catch (err) {
      // keep the default fallback list if the engine is unreachable
    }
  },
  computed: {
    providerOptions() {
      return [
        { key: 'azure', label: 'Azure' },
        { key: 'qdrant', label: 'Qdrant' }
      ]
    },
    config() {
      if (this.provider !== 'qdrant') return { provider: 'azure' }
      return {
        provider: 'qdrant',
        provider_params: { embeddingModel: this.embeddingModel }
      }
    }
  },
  watch: {
    config: {
      deep: true,
      handler(config) {
        this.$emit('input', config)
      }
    }
  }
}
</script>
